<script>
import { CorporateLayout } from "../controllers/dashboard.layout";
import Swiper, { Pagination, Autoplay, Navigation } from 'swiper';
import 'swiper/swiper-bundle.css';

// Install Swiper modules
Swiper.use([Pagination, Autoplay, Navigation]);

export default {
    name: "CorporateLayout",
    mixins: [CorporateLayout],
    mounted() {
        new Swiper('.swiper-container', {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                type: 'bullets',
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            }
        });
    }
}
</script>

<template>
    <!-- Content ============================================= -->
    <div id="content" class="py-4">
        <div class="container">
            <div class="row flex-row-reverse">
                <keep-alive>
                    <transition name="slide-in-left">
                        <router-view :permissions="user.permissions"></router-view>
                    </transition>
                </keep-alive>

                <aside class="col-lg-3 d-none d-lg-block">
                    <div class="bg-light shadow-sm rounded text-center p-3 mb-4">
                        <div class="profile-thumb mt-3 mb-4">
                            <img height="100" width="100" class="rounded-circle"
                                 :src="user.corporate.logo || '/images/business/avatar.jpg'" alt="">
                            <div class="profile-thumb-edit bg-primary text-white" data-bs-toggle="tooltip" title=""
                                 data-bs-original-title="Change Profile Picture">
                                <i class="fas fa-camera position-absolute"></i>
                                <input @change="uploadProfile" type="file" class="custom-file-input" id="customFile"
                                       accept="image/*">
                            </div>
                        </div>
                        <p class="text-3 font-weight-500 mb-2">
                            Hello, {{ user.name }}
                            <router-link to="/business/profile" title="Edit Profile" class="opacity-6">
                                <i class="fas fa-edit"></i>
                            </router-link>
                        </p>
                        <p v-if="user.corporate" class="text-2 font-weight-700 mb-2">
                            {{ user.corporate.name }} <br>
                            <span class="text-black-50 font-weight-100">{{ user.corporate.address }}</span>
                        </p>
                    </div>

                    <!-- Available Balance =============================== -->
                    <div class="swiper-container mb-4">
                        <div class="swiper-container-title"></div>
                        <div class="swiper-navigation-group">
                            <div class="swiper-button-prev"></div>
                            <div class="swiper-button-next"></div>
                        </div>
                        <div class="swiper-wrapper">
                            <div class="swiper-slide">
                                <div class="bg-light shadow-sm rounded text-center p-3">
                                    <div class="text-17 text-light my-3"><i class="fas fa-building"></i></div>
                                    <h3 class="text-3 font-weight-400 my-4">Receive Payments</h3>
                                    <p class="text-muted opacity-8 mb-4">
                                        Receive payments seamlessly from international and local customers
                                    </p>
                                    <router-link to="/business/payments" class="btn btn-primary btn-block">View Billers</router-link>
                                </div>
                            </div>
                            <div class="swiper-slide">
                                <div class="bg-light shadow-sm rounded text-center p-3">
                                    <div class="text-17 text-light my-3"><i class="fas fa-wallet"></i></div>
                                    <h3 class="text-3 font-weight-400 my-4">Wallets</h3>
                                    <p class="text-muted opacity-8 mb-4">
                                        Manage and track your wallet balances and transactions
                                    </p>
                                    <router-link to="/business/wallets" class="btn btn-primary btn-block">View Wallets</router-link>
                                </div>
                            </div>
                            <div class="swiper-slide">
                                <div class="bg-light shadow-sm rounded text-center p-3">
                                    <div class="text-17 text-light my-3"><i class="fas fa-calendar-alt"></i></div>
                                    <h3 class="text-3 font-weight-400 my-4">Events</h3>
                                    <p class="text-muted opacity-8 mb-4">
                                        Create an unforgettable experience for your customers
                                    </p>
                                    <router-link to="/business/events" class="btn btn-primary btn-block">View Events</router-link>
                                </div>
                            </div>
                            <div class="swiper-slide">
                                <div class="bg-light shadow-sm rounded text-center p-3">
                                    <div class="text-17 text-light my-3"><i class="fas fa-layer-group"></i></div>
                                    <h3 class="text-3 font-weight-400 my-4">Stored Accounts</h3>
                                    <p class="text-muted opacity-8 mb-4">
                                        Save and access your saved accounts
                                    </p>
                                    <router-link to="/business/accounts" class="btn btn-primary btn-block">View Accounts</router-link>
                                </div>
                            </div>
                            <div class="swiper-pagination swiper-pagination-bullets"></div>
                        </div>

                    </div>
                    <!-- Available Balance End -->

                    <div class="bg-light shadow-sm rounded text-center p-3 mb-4">
                        <h3 class="text-3 font-weight-400 my-4">Tax Clearance Certificate</h3>
                        <p class="text-muted opacity-8 mb-4">
                            Magetsi has a valid certificate which you can download below
                        </p>
                        <a href="/Magetsi%20Tax%20Clearance.pdf" target="_blank"
                           class="btn btn-outline-primary btn-block shadow-none">Download</a>
                    </div>
                </aside>
            </div>
        </div>
    </div>
    <!-- Content end -->
</template>

<style>
.swiper-container {
    width: 100%;
    height: auto;
    overflow: hidden;
    position: relative;
    padding-bottom: 30px;
}

.swiper-slide {
    width: 100% !important;
}

.swiper-pagination {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 100%;
}

.swiper-pagination-bullet {
    width: 8px;
    height: 8px;
    margin: 0 4px;
    background: #ccc;
    opacity: 0.5;
    border-radius: 50%;
    display: inline-block;
    transition: all 0.3s ease;
}

.swiper-pagination-bullet-active {
    background: #28a745;
    opacity: 1;
}

.swiper-container {
    position: relative;
}

.swiper-navigation-group {
    position: absolute;
    top: 10px;
    right: 10px;
    display: flex;
    flex-direction: row;
    z-index: 11;
}

.swiper-button-next,
.swiper-button-prev {
    color: #28a745;
    background: #fff;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
    position: static;
    margin: 0;
    z-index: 10;
}

.swiper-button-prev {
    border-radius: 4px 0 0 4px;
    border-right: 1px solid rgba(0,0,0,0.05);
}

.swiper-button-next {
    border-radius: 0 4px 4px 0;
}

/* Hide the default button arrows */
.swiper-button-next:after,
.swiper-button-prev:after {
    font-size: 13px;
}

.swiper-container-title {
    position: absolute;
    top: 10px;
    left: 15px;
    font-weight: 500;
    color: #28a745;
    z-index: 10;
    font-size: 1.1rem;
}

/* Make navigation chevrons smaller by 5px */
.swiper-button-next::after,
.swiper-button-prev::after {
    font-size: 15px; /* Default is 25px in Swiper */
}
</style>
